export enum COST_CALCULATION_TYPE {
  NET_COST = "NetCost",
  LIST = "List",
}
